import {User} from "@irati/types"
import {DistributeRewardRecipient, DistributeRewardImportType} from "../../enums/DistributeRewardTypes"
import {
  SetHandleUserPointsPayload,
  SetMessagePayload,
  SetRecognitionPayload,
  SwitchRecipientPayload,
  UpdateImportTypePayload,
  UpdateRecipientsPayload,
  SetModalErrorStatePayload,
  SetBulkRewardPayload,
  DistributeRewardState
} from "./actions"

export const updateRewardRecipientType = (state: DistributeRewardState, payload: SwitchRecipientPayload): DistributeRewardState => {
  return {
    ...state,
    userEmails: [],
    destinationUsers: [],
    recipientType: payload.recipientType,
    rewardImportType:
      payload.recipientType === DistributeRewardRecipient.MANAGER
        ? DistributeRewardImportType.MANUAL_ENTER
        : DistributeRewardImportType.IMPORT_CSV
  }
}
export const updateRewardImportType = (state: DistributeRewardState, payload: UpdateImportTypePayload): DistributeRewardState => {
  return {
    ...state,
    userEmails: [],
    destinationUsers: [],
    rewardImportType: payload.importType
  }
}
export const updateRecipientsList = (state: DistributeRewardState, payload: UpdateRecipientsPayload): DistributeRewardState => {
  if (state.recipientType === DistributeRewardRecipient.MANAGER) {
    return {
      ...state,
      destinationUsers: payload.recipientsList as User[]
    }
  }
  return {
    ...state,
    destinationUsers: state.rewardImportType === DistributeRewardImportType.MANUAL_ENTER ? (payload.recipientsList as User[]) : [],
    userEmails: state.rewardImportType === DistributeRewardImportType.IMPORT_CSV ? (payload.recipientsList as string[]) : []
  }
}
export const updateUserPoints = (state: DistributeRewardState, payload: SetHandleUserPointsPayload): DistributeRewardState => {
  return {
    ...state,
    pointsPerUser: parseInt(payload.userPoints, 10)
  }
}
export const updateRewardMessage = (state: DistributeRewardState, payload: SetMessagePayload): DistributeRewardState => {
  return {
    ...state,
    message: payload.message,
    recognition: {
      ...state.recognition,
      message: payload.message
    }
  }
}
export const updateRecognition = (state: DistributeRewardState, payload: SetRecognitionPayload): DistributeRewardState => {
  return {
    ...state,
    recognition: {...state.recognition, ...payload.recognition}
  }
}
export const updateBulkRewardState = (state: DistributeRewardState, payload: SetBulkRewardPayload): DistributeRewardState => {
  return {
    ...state,
    bulkRewardState: {...state.bulkRewardState, ...payload}
  }
}
export const updateErrorState = (state: DistributeRewardState, payload: SetModalErrorStatePayload): DistributeRewardState => {
  return {
    ...state,
    modalErrorState: payload
  }
}
export const onAcceptEmailErrors = (state: DistributeRewardState): DistributeRewardState => {
  const isValidEmail = (email: string) => !state.bulkRewardState.failedEmails.find(({email: failedEmail}) => failedEmail === email)
  const validEmails = state.userEmails.filter(isValidEmail)
  
  return {
    ...state,
    userEmails: validEmails,
    bulkRewardState: {
      ...state.bulkRewardState,
      failedEmails: []
    }
  }
}
export const onRejectEmailErrors = (state: DistributeRewardState): DistributeRewardState => {
  return {
    ...state,
    bulkRewardState: {
      ...state.bulkRewardState,
      failedEmails: []
    }
  }
}

export const defaultAction = (state: DistributeRewardState) => state
